var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRobotFace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12C8.88 12 8 12.88 8 14C8 15.12 8.88 16 10 16C11.12 16 12 15.12 12 14C12 12.88 11.12 12 10 12Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12C16.88 12 16 12.88 16 14C16 15.12 16.88 16 18 16C19.12 16 20 15.12 20 14C20 12.88 19.12 12 18 12Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 24C24 25.103 23.103 26 22 26H6C4.897 26 4 25.103 4 24V8C4 6.897 4.897 6 6 6H22C23.103 6 24 6.897 24 8V24ZM28 14V12H26V8C26 5.794 24.206 4 22 4H20V0H18V4H10V0H8V4H6C3.794 4 2 5.794 2 8V12H0V14H2V19H0V21H2V24C2 26.206 3.794 28 6 28H22C24.206 28 26 26.206 26 24V21H28V19H26V14H28Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 22.9958C11.65 22.9958 9.46999 21.8258 8.16699 19.8668L9.83299 18.7598C10.764 20.1598 12.321 20.9958 14 20.9958C15.679 20.9958 17.236 20.1598 18.167 18.7598L19.833 19.8668C18.53 21.8258 16.35 22.9958 14 22.9958Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotFace);
export default __webpack_public_path__ + "static/media/robot-face.b3cc48000b8d9ccec0540f3d28e765ea.svg";
export { ForwardRef as ReactComponent };